/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { documentService } from '../../../../api/services/documentService';
import {
  setEmployeeActiveDocs,
  setEmployeeActiveDocsLoader,
} from '../../../../infra/aggregates/myProfile/DocumentAggregates/getActiveEmpDocsSlice';

interface PropsValues {
  setDocumentsData: (data: any) => void;
}
function DTOActiveDocs({ setDocumentsData }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const all_Docs = useAppSelector(
    (state) => state.getActiveEmpDocsSlice.empDocsData,
  );
  const dispatch = useAppDispatch();
  const full_path = '';

  async function getEmployeeDocuments(
    companyId: number,
    empId: number,
    full_path: string,
  ) {
    dispatch(setEmployeeActiveDocsLoader(true));
    const response: any = await documentService.getActiveDocs(
      companyId,
      empId,
      full_path,
    );

    if (response.response == 'success') {
      const empDocsData: any = response?.data;

      dispatch(setEmployeeActiveDocs(empDocsData));
      /* Passing Props to Controller */

      setDocumentsData(empDocsData);
      dispatch(setEmployeeActiveDocsLoader(false));
    } else {
      dispatch(setEmployeeActiveDocsLoader(false));
      return;
    }
  }
  useEffect(() => {
    getEmployeeDocuments(selector.company_id, selector.emp_id, full_path);
  }, []);

  useEffect(() => {
    setDocumentsData(all_Docs);
  }, [all_Docs]);

  return <></>;
}
export default DTOActiveDocs;
